// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2yudc","label":"Category_label__Xx3Ey","content":"Category_content__18XwL","header":"Category_header__L8TMM","location":"Category_location__1xFgJ"};